import { useEvent, useList, useStore } from 'effector-react'
import {
    $foundSuggestions,
    $isFoundSuggestions,
    $suggestSearchPending,
    searchSuggestion,
    selectSuggestion
} from 'src/features/suggestions/model'
import * as S from './desktop.styled'
import React from 'react'
import { $isOpenedSearchSection, $searchText } from 'src/features/search-goods/model'
import { RowDesktop, RowDesktopSkeleton } from 'src/shared/ui/templates/row-desktop'
import dynamic from 'next/dynamic'

function SuggestionsSearchSkeleton() {
    return (
        <React.Fragment>
            <RowDesktopSkeleton />
            <RowDesktopSkeleton />
            <RowDesktopSkeleton />
            <RowDesktopSkeleton />
            <RowDesktopSkeleton />
        </React.Fragment>
    )
}

const HistoryBlock = dynamic(() => import('./history-desktop').then((x) => x.HistoryBlock), {
    ssr: false
})

function SearchAllBlock() {
    const text = useStore($searchText)
    const searchHandler = useEvent(searchSuggestion)
    if (!text || text.length < 3) return <React.Fragment />
    return (
        <React.Fragment>
            <RowDesktop onClick={() => searchHandler(text)} title={text} description={'Все результаты поиска'} />
        </React.Fragment>
    )
}

export function SuggestionsSearchDesktop() {
    const isLoading = useStore($suggestSearchPending)
    const isVisibleSuggestions = useStore($isOpenedSearchSection)
    const isNotEmpty = useStore($isFoundSuggestions)
    const select = useEvent(selectSuggestion)
    const selectHandler = (e: React.MouseEvent<HTMLDivElement> | React.TouchEvent<HTMLDivElement>) => {
        const id = (e.currentTarget as HTMLDivElement)?.getAttribute('data-row-id')
        if (id === null) throw new Error('Error on select suggestion id not found')
        select(id)
    }
    const suggestions = useList($foundSuggestions, {
        fn: (item) => (
            <RowDesktop
                dataId={item.id}
                onClick={selectHandler}
                title={item.title}
                description={item.suggestionTypeTitle}
            />
        ),
        getKey: (item) => item.id
    })

    if (isLoading)
        return (
            <S.Container isVisible={isVisibleSuggestions}>
                <S.SuggestWrapper>
                    <SuggestionsSearchSkeleton />
                </S.SuggestWrapper>
            </S.Container>
        )
    return (
        <S.Container isVisible={isVisibleSuggestions}>
            <S.SuggestWrapper>
                {suggestions}
                <SearchAllBlock />
                {!isNotEmpty && <HistoryBlock selectHandler={selectHandler} />}
            </S.SuggestWrapper>
        </S.Container>
    )
}
